import { Box, HStack, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { CherryPayApi } from "../../api/models";
import { MapPinIcon } from "../../styles/icons";
import { isEmptyStr } from "../../util/StringUtil";

interface GeoLocationCardViewProps {
  location: CherryPayApi.GeoLocation;
  overrideMessage?: string | null;
  isSelected?: boolean;
  onSelect?: () => void;
  headerSlot?: React.ReactNode;
  editorSlot?: React.ReactNode;
}

export const GeoLocationCardView: React.FC<GeoLocationCardViewProps> = ({
  location,
  overrideMessage,
  isSelected = false,
  onSelect,
  headerSlot,
  editorSlot,
}) => {
  const hasAddress = !isEmptyStr(location.Address ?? undefined);
  const hasOverride = !isEmptyStr(overrideMessage ?? undefined);
  const isClickable = !!onSelect;

  return (
    <Box
      width="100%"
      border="1px solid"
      borderColor={isSelected ? "cherryBorder.800" : "cherryBorder.100"}
      borderRadius="lg"
      p={4}
      cursor={isClickable ? "pointer" : undefined}
      onClick={onSelect}
      role={isClickable ? "button" : undefined}
      aria-pressed={isClickable ? isSelected : undefined}
    >
      <VStack alignItems="flex-start" spacing={3} width="100%">
        <HStack alignItems="flex-start" spacing={2} width="100%">
          <MapPinIcon color="cherryUi.600" boxSize={5} mt={0.5} />
          <VStack alignItems="flex-start" spacing={0} flex="1">
            <Text fontSize="md" fontWeight="700" color="gray.800">
              {location.DisplayName || "Unnamed Location"}
            </Text>
            {hasAddress && (
              <Text fontSize="sm" color="gray.600">
                {location.Address}
              </Text>
            )}
          </VStack>
          {headerSlot}
        </HStack>

        <Box
          width="100%"
          bg="cherryBackground.subtleTile"
          borderRadius="md"
          p={3}
        >
          <Text fontSize="sm" color="gray.600" mb={1}>
            DEFAULT LOCATION MESSAGE
          </Text>
          <Text fontSize="sm" color="gray.800">
            {location.RelevantText}
          </Text>
        </Box>

        {!editorSlot && hasOverride && (
          <Box width="100%" bg="campaignMessage.bg" borderRadius="md" p={3}>
            <Text
              fontSize="xs"
              color="campaignMessage.label"
              fontWeight="600"
              textTransform="uppercase"
              mb={1}
            >
              Campaign Message
            </Text>
            <Text fontSize="sm" color="gray.800">
              {overrideMessage}
            </Text>
          </Box>
        )}

        {editorSlot}
      </VStack>
    </Box>
  );
};
